import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ConversationsEmbeddedReport from './report/conversations_embedded_report';

export default function ConversationsPanel({ onStatusChange }) {
  return (
    <PanelWrapper>
      <ConversationsEmbeddedReport kind="CONVERSATIONS" onStatusChange={onStatusChange} />
    </PanelWrapper>
  );
}

ConversationsPanel.propTypes = {
  onStatusChange: PropTypes.func,
};

const PanelWrapper = styled.div`
  height: 100%;
  width: 100%;
`;
